// var EventBus
export default {
    $has(event) {
        var handlers = this['handler_of_' + event]; // 监听函数
        return !!handlers;
    },

    // 发送事件
    $emit(...args) {
        var event = args[0]; // 事件
        var handlers = this['handler_of_' + event]; // 监听函数
        var parameters = args.slice(1); // 截取参数部分

        if ( !handlers ) {
            console.log('#10 handler_of_' + event + ' not found', parameters, this);
            return;
        }

        // console.log('#19 emit, event', event, 'handlers', handlers);

        for(var i = 0; i < handlers.length; i++ ) {
            handlers[i](...parameters); // 展开传给监听函数
        }
    },

    $once(event, handler) {
        this['handler_of_' + event] = [handler]; // 多次注册也只有一个
    },

    // 注册事件监听
    $on(event, handler) {
        if(!this['handler_of_' + event]) {
            this['handler_of_' + event] = [handler]; // 第一个
            return;
        }

        this['handler_of_' + event].push(handler); // 数组增加
    }
};


// WEBPACK FOOTER //
// ./src/assets/EventBus.js